import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full overflow-y-auto p-6 bg-slate-50 dark:bg-slate-900/50 flex flex-col gap-6" }
const _hoisted_2 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_3 = { class: "flex items-center justify-between border-b pb-2" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "flex flex-wrap gap-3" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4 flex-1" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-1 pr-2 border-r shrink-0" }
const _hoisted_12 = ["onClick", "disabled"]
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = {
  key: 0,
  class: "flex-1 flex flex-wrap items-center gap-2 pl-2"
}
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = {
  key: 1,
  class: "flex-1 flex flex-wrap items-center gap-2 pl-2"
}
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "text-xs text-muted-foreground"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "text-center text-muted-foreground py-8 border-2 border-dashed rounded-md"
}
const _hoisted_32 = { class: "text-sm font-bold p-2 bg-muted-foreground/10 text-muted-foreground flex items-center justify-between border-b shrink-0" }

import { ref, watch } from 'vue'
import { Button } from '@/components/ui/button'
import { ArrowRightLeft, Plus, Trash2, RefreshCw, MessageSquare, User, Box } from 'lucide-vue-next'
import BaseVisualEditor from './BaseVisualEditor.vue'
import MermaidCodeEditor from './MermaidCodeEditor.vue'
import MermaidLivePreview from './MermaidLivePreview.vue'

interface SeqEntity {
  id: string
  type: 'actor' | 'participant'
}

interface SeqAction {
  type: 'message' | 'note'
  from: string
  to: string
  arrow: string
  text: string
  notePosition: 'left of' | 'right of' | 'over'
}

// Estado visual

export default /*@__PURE__*/_defineComponent({
  __name: 'SequenceEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const showCode = ref(true)
const copied = ref(false)
const editableCode = ref('')

// Interfaces
const autonumber = ref(true)
const entities = ref<SeqEntity[]>([
  { id: 'Cliente', type: 'actor' },
  { id: 'Servidor', type: 'participant' },
  { id: 'BaseDeDatos', type: 'participant' }
])

const actions = ref<SeqAction[]>([
  { type: 'message', from: 'Cliente', arrow: '->>', to: 'Servidor', text: 'Solicitar datos', notePosition: 'over' },
  { type: 'message', from: 'Servidor', arrow: '->>', to: 'BaseDeDatos', text: 'Consulta SQL', notePosition: 'over' },
  { type: 'message', from: 'BaseDeDatos', arrow: '-->>', to: 'Servidor', text: 'Resultados', notePosition: 'over' },
  { type: 'note', from: 'Servidor', arrow: '->>', to: 'Servidor', text: 'Procesa la información', notePosition: 'right of' },
  { type: 'message', from: 'Servidor', arrow: '-->>', to: 'Cliente', text: 'Respuesta JSON', notePosition: 'over' }
])

const arrowTypes = [
  { value: '->>', label: 'Sólida con flecha (->>)' },
  { value: '-->>', label: 'Punteada con flecha (-->>)' },
  { value: '->', label: 'Sólida sin flecha (->)' },
  { value: '-->', label: 'Punteada sin flecha (-->)' },
  { value: '-x', label: 'Sólida cruzada (-x)' },
  { value: '--x', label: 'Punteada cruzada (--x)' }
]

// Acciones Entidades
const addEntity = () => {
  entities.value.push({ id: `Entidad_${entities.value.length + 1}`, type: 'participant' })
}
const removeEntity = (idx: number) => {
  entities.value.splice(idx, 1)
}

// Acciones Mensajes
const addMessage = () => {
  const from = entities.value.length > 0 ? entities.value[0].id : 'A'
  const to = entities.value.length > 1 ? entities.value[1].id : from
  actions.value.push({ type: 'message', from, arrow: '->>', to, text: 'Nuevo mensaje', notePosition: 'over' })
}

const addNote = () => {
  const from = entities.value.length > 0 ? entities.value[0].id : 'A'
  actions.value.push({ type: 'note', from, arrow: '->>', to: from, text: 'Nueva nota', notePosition: 'over' })
}

const removeAction = (idx: number) => {
  actions.value.splice(idx, 1)
}

const moveActionUp = (idx: number) => {
  if (idx > 0) {
    const temp = actions.value[idx]
    actions.value[idx] = actions.value[idx - 1]
    actions.value[idx - 1] = temp
  }
}

const moveActionDown = (idx: number) => {
  if (idx < actions.value.length - 1) {
    const temp = actions.value[idx]
    actions.value[idx] = actions.value[idx + 1]
    actions.value[idx + 1] = temp
  }
}

// Generar Mermaid
const generateMermaid = () => {
  let code = `sequenceDiagram\n`
  
  if (autonumber.value) {
    code += `    autonumber\n`
  }

  entities.value.forEach(e => {
    if (e.id.trim()) {
      code += `    ${e.type} ${e.id.trim()}\n`
    }
  })

  actions.value.forEach(act => {
    const safeFrom = act.from.trim()
    const safeTo = act.to.trim()
    
    if (act.type === 'message') {
      if (safeFrom && safeTo) {
        code += `    ${safeFrom}${act.arrow}${safeTo}: ${act.text}\n`
      }
    } else if (act.type === 'note') {
      if (safeFrom && safeTo && safeFrom !== safeTo) {
        code += `    Note ${act.notePosition} ${safeFrom},${safeTo}: ${act.text}\n`
      } else if (safeFrom) {
        code += `    Note ${act.notePosition} ${safeFrom}: ${act.text}\n`
      }
    }
  })
  
  editableCode.value = code
}

// Sincronizar Visual
const syncToVisual = () => {
  const code = editableCode.value
  const lines = code.split('\n')
  
  const newEntities: SeqEntity[] = []
  const newActions: SeqAction[] = []
  let newAutonumber = false
  
  const entityRegex = /^(actor|participant)\s+(.+)$/
  const noteRegex = /^Note\s+(left of|right of|over)\s+([^:]+):\s*(.+)$/
  const msgRegex = /^([^-]+)\s*(-+(?:x|>>|>))\s*([^:]+)\s*:\s*(.+)$/

  for (const line of lines) {
    const t = line.trim()
    if (!t || t === 'sequenceDiagram') continue

    if (t === 'autonumber') {
      newAutonumber = true
    } else if (entityRegex.test(t)) {
      const match = t.match(entityRegex)!
      // Si tiene alias (Participant A as B), no lo soportamos perfecto en visual, pero tomaremos todo
      newEntities.push({
        type: match[1] as 'actor' | 'participant',
        id: match[2].trim()
      })
    } else if (noteRegex.test(t)) {
      const match = t.match(noteRegex)!
      const pos = match[1] as 'left of' | 'right of' | 'over'
      const targets = match[2].split(',').map(s => s.trim())
      newActions.push({
        type: 'note',
        notePosition: pos,
        from: targets[0],
        to: targets.length > 1 ? targets[1] : targets[0],
        arrow: '->>',
        text: match[3].trim()
      })
    } else if (msgRegex.test(t)) {
      const match = t.match(msgRegex)!
      newActions.push({
        type: 'message',
        from: match[1].trim(),
        arrow: match[2].trim(),
        to: match[3].trim(),
        text: match[4].trim(),
        notePosition: 'over'
      })
    }
  }

  autonumber.value = newAutonumber
  
  // No sobreescribir entidades si no hay ninguna explícita, porque Mermaid las infiere
  if (newEntities.length > 0) {
    entities.value = newEntities
  }
  
  if (newActions.length > 0) {
    actions.value = newActions
    
    // Si no declararon entidades explícitas, inferirlas de los mensajes
    if (newEntities.length === 0) {
      const inferred = new Set<string>()
      newActions.forEach(a => {
        if (a.from) inferred.add(a.from)
        if (a.to) inferred.add(a.to)
      })
      entities.value = Array.from(inferred).map(id => ({ id, type: 'participant' }))
    }
  }
}

// Watchers
watch(() => props.open, (newVal) => {
  if (newVal) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        editableCode.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        syncToVisual();
      }, 300);
      return;
    }
  }

  if (newVal && !editableCode.value) {
    generateMermaid()
  }
}, { immediate: true })

watch([autonumber, entities, actions], () => {
  generateMermaid()
}, { deep: true })

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(editableCode.value)
    copied.value = true
    setTimeout(() => copied.value = false, 2000)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}

const saveAndClose = () => {
  emit('save', editableCode.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseVisualEditor, {
    open: __props.open,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:open', $event))),
    title: "Diagrama de Secuencia",
    description: "Modela el flujo de mensajes e interacciones entre sistemas, objetos o roles a lo largo del tiempo.",
    showCode: showCode.value,
    "onUpdate:showCode": _cache[3] || (_cache[3] = ($event: any) => (showCode.value = $event)),
    copied: copied.value,
    onCopy: copyToClipboard,
    onSave: saveAndClose
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(ArrowRightLeft), { class: "w-5 h-5 text-primary" })
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: addMessage
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MessageSquare), { class: "w-4 h-4 mr-2" }),
          _cache[4] || (_cache[4] = _createTextVNode(" Añadir Mensaje", -1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        size: "sm",
        variant: "secondary",
        onClick: addNote
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Box), { class: "w-4 h-4 mr-2" }),
          _cache[5] || (_cache[5] = _createTextVNode(" Añadir Nota", -1))
        ]),
        _: 1
      })
    ]),
    canvas: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "font-semibold text-lg" }, "Participantes / Actores", -1)),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "autonumber",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((autonumber).value = $event)),
                class: "w-4 h-4 text-primary rounded"
              }, null, 512), [
                [_vModelCheckbox, autonumber.value]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "autonumber",
                class: "text-sm cursor-pointer select-none"
              }, "Auto-numerar mensajes", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (entity, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "flex items-center gap-2 bg-muted p-2 rounded-md border group"
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((entity.type) = $event),
                  class: "bg-background border rounded px-2 py-1 text-xs focus:outline-none focus:ring-1"
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: "actor" }, "Actor", -1),
                  _createElementVNode("option", { value: "participant" }, "Caja", -1)
                ]))], 8, _hoisted_6), [
                  [_vModelSelect, entity.type]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((entity.id) = $event),
                  class: "bg-transparent border-b border-transparent focus:border-primary px-1 py-1 text-sm font-semibold w-24 focus:outline-none",
                  placeholder: "Nombre"
                }, null, 8, _hoisted_7), [
                  [_vModelText, entity.id]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeEntity(idx)),
                  class: "text-muted-foreground hover:text-destructive opacity-0 group-hover:opacity-100 transition-opacity"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_8)
              ]))
            }), 128)),
            _createVNode(_unref(Button), {
              variant: "outline",
              size: "sm",
              class: "border-dashed",
              onClick: addEntity
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus), { class: "w-4 h-4" })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "font-semibold text-lg border-b pb-2" }, "Flujo de Interacción", -1)),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "flex items-center gap-2 bg-background border p-2 rounded-md shadow-sm relative group"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (moveActionUp(idx)),
                    disabled: idx === 0,
                    class: "text-muted-foreground hover:text-primary disabled:opacity-30"
                  }, "▲", 8, _hoisted_12),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (moveActionDown(idx)),
                    disabled: idx === actions.value.length - 1,
                    class: "text-muted-foreground hover:text-primary disabled:opacity-30"
                  }, "▼", 8, _hoisted_13)
                ]),
                (action.type === 'message')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_unref(MessageSquare), { class: "w-4 h-4 text-blue-500 shrink-0" }),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((action.from) = $event),
                        class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none min-w-[100px]"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (e) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: e.id,
                            value: e.id
                          }, _toDisplayString(e.id), 9, _hoisted_16))
                        }), 128))
                      ], 8, _hoisted_15), [
                        [_vModelSelect, action.from]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((action.arrow) = $event),
                        class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none"
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(arrowTypes, (arr) => {
                          return _createElementVNode("option", {
                            key: arr.value,
                            value: arr.value
                          }, _toDisplayString(arr.label), 9, _hoisted_18)
                        }), 64))
                      ], 8, _hoisted_17), [
                        [_vModelSelect, action.arrow]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((action.to) = $event),
                        class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none min-w-[100px]"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (e) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: e.id,
                            value: e.id
                          }, _toDisplayString(e.id), 9, _hoisted_20))
                        }), 128))
                      ], 8, _hoisted_19), [
                        [_vModelSelect, action.to]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((action.text) = $event),
                        class: "flex-1 min-w-[150px] border rounded px-3 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-primary",
                        placeholder: "Mensaje..."
                      }, null, 8, _hoisted_21), [
                        [_vModelText, action.text]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_unref(Box), { class: "w-4 h-4 text-amber-500 shrink-0" }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-xs font-bold uppercase text-muted-foreground" }, "Nota", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((action.notePosition) = $event),
                        class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none"
                      }, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("option", { value: "left of" }, "Izquierda de", -1),
                        _createElementVNode("option", { value: "right of" }, "Derecha de", -1),
                        _createElementVNode("option", { value: "over" }, "Sobre", -1)
                      ]))], 8, _hoisted_23), [
                        [_vModelSelect, action.notePosition]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((action.from) = $event),
                        class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none min-w-[100px]"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (e) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: e.id,
                            value: e.id
                          }, _toDisplayString(e.id), 9, _hoisted_25))
                        }), 128))
                      ], 8, _hoisted_24), [
                        [_vModelSelect, action.from]
                      ]),
                      (action.notePosition === 'over')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "y"))
                        : _createCommentVNode("", true),
                      (action.notePosition === 'over')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            "onUpdate:modelValue": ($event: any) => ((action.to) = $event),
                            class: "bg-muted border rounded px-2 py-1 text-xs focus:outline-none min-w-[100px]"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (e) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: e.id,
                                value: e.id
                              }, _toDisplayString(e.id), 9, _hoisted_28))
                            }), 128))
                          ], 8, _hoisted_27)), [
                            [_vModelSelect, action.to]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((action.text) = $event),
                        class: "flex-1 min-w-[150px] border rounded px-3 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-primary bg-amber-500/10",
                        placeholder: "Contenido de la nota..."
                      }, null, 8, _hoisted_29), [
                        [_vModelText, action.text]
                      ])
                    ])),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeAction(idx)),
                  class: "text-muted-foreground hover:bg-destructive hover:text-white p-2 rounded-full transition-colors shrink-0"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_30)
              ]))
            }), 128)),
            (actions.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Aún no hay interacciones. "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    "code-panel": _withCtx(() => [
      _createElementVNode("div", _hoisted_32, [
        _cache[13] || (_cache[13] = _createTextVNode(" Mermaid (Sincronizado) ", -1)),
        _createVNode(_unref(Button), {
          size: "sm",
          variant: "default",
          class: "h-7 text-xs",
          onClick: syncToVisual
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshCw), { class: "w-3 h-3 mr-2" }),
            _cache[12] || (_cache[12] = _createTextVNode(" Sincronizar a Visual ", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(MermaidCodeEditor, {
        modelValue: editableCode.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableCode).value = $event)),
        class: "flex-1 min-h-0"
      }, null, 8, ["modelValue"])
    ]),
    "live-preview": _withCtx(() => [
      _createVNode(MermaidLivePreview, { code: editableCode.value }, null, 8, ["code"])
    ]),
    _: 1
  }, 8, ["open", "showCode", "copied"]))
}
}

})